import React, { useEffect, useState } from "react";
import "./Events.css";
import event1 from "../../Assets/event/sport.png";
import cultural from "../../Assets/event/culture.png";
import achievements from "../../Assets/event/achivements.png";
import campus from "../../Assets/event/campus.png";
import gallery from "../../Assets/event/gallery.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../../common";
import backgroundImage from "../../Assets/eventsimgbg.png";
// import EventsScreen from "../EventsScreen";
const Events = () => {
  const [events, setEvents] = useState([]);
  const [uniqueCategoryNames, setUniqueCategoryNames] = useState([]);
  const navigate = useNavigate(); // useNavigate hook for navigation

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(SummaryApi.getevents.url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.data) {
          setEvents(data.data);
          // Get the last 5 events and filter unique category names
          const lastFiveEvents = data.data.slice(-5);
          const categoryNames = lastFiveEvents.map(
            (event) => event.category_name
          );
          // Remove duplicates using Set
          const uniqueCategories = [...new Set(categoryNames)];
          setUniqueCategoryNames(uniqueCategories);
        }
      })
      .catch((error) => console.error("Error fetching events:", error));
  }, []);
  // Function to handle click on an event category
  const handleEventClick = (event) => {
    // Pass all events along with the clicked event to the EventsScreen
    navigate("/events-screen", {
      state: {
        eventDetails: event,
        allEvents: events,
      },
    });
  };
  return (
    <div
      className="bg-cover bg-no-repeat bg-center "
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="pt-7 ml-[0%] mr-[0%] sm:mr-[0%] md:mr-[5%] lg:mr-[0%] xl:mr-[0%] 2xl:mr-[0%] sm:ml-[10%] md:ml-[5%] lg:ml-[10%] xl:ml-[10%] 2xl:ml-[10%] sm:pt-10 md:pt-10 lg:pt-10 xl:pt-10 2xl:pt-10 ">
        <div>
          <h1 className="text-4xl text-center eventsh1">EVENTS</h1>
        </div>
        <div className="container">
          {/* First Column */}
          <div className="column first-column mt-[-45%] ml-[0%] sm:ml-[0%] md:ml-[0%] lg:ml-[0%] xl:ml-[-30%] 2xl:ml-[0%]">
            {uniqueCategoryNames.includes("Cultural Activities") && (
              <div
                onClick={() =>
                  handleEventClick(
                    events.find(
                      (event) => event.category_name === "Cultural Activities"
                    )
                  )
                }
              >
                <div className="image-box">
                  <h3 style={{ cursor: "pointer",color:'red',color:'red' }} >
                    Cultural Activities
                  </h3>
                  <img src={cultural} alt="Culture" className="pt-4" />
                </div>
                <div className="arrow  ml-[84%] sm:ml-[95%] md:ml-[87%] lg:ml-[95%] xl:ml-[93%] 2xl:ml-[93%] pt-2">
                  <FaArrowRightLong />
                </div>
              </div>
            )}
            {uniqueCategoryNames.includes("Achievements") && (
              <div
                onClick={() =>
                  handleEventClick(
                    events.find(
                      (event) => event.category_name === "Achievements"
                    )
                  )
                }
                className="image-box"
              >
                <h3 style={{ cursor: "pointer",color:'red' }}>Achievements</h3>
                <img src={achievements} alt="Achievements" className="pt-4" />
                <div className="arrow  ml-[84%] sm:ml-[95%] md:ml-[95%] lg:ml-[95%] xl:ml-[93%] 2xl:ml-[93%] pt-2">
                  <FaArrowRightLong />
                </div>
              </div>
            )}
          </div>
          {/* Center Column */}
          <div className="column center-column mt-[-45%] ml-[-30%] ml-[0%] sm:ml-[0%] md:ml-[0%] lg:ml-[0%] xl:ml-[-30%] 2xl:ml-[0%]">
            {uniqueCategoryNames.includes("Gallery") && (
              <div
                onClick={() =>
                  handleEventClick(
                    events.find((event) => event.category_name === "Gallery")
                  )
                }
              >
                <div className="image-box">
                  <h3 style={{ cursor: "pointer",color:'red' }}>Gallery</h3>
                  <img src={gallery} alt="Gallery" className="pt-4" />
                </div>
                <div className="arrow  ml-[84%] sm:ml-[95%] md:ml-[95%] lg:ml-[95%] xl:ml-[93%] 2xl:ml-[93%] pt-2">
                  <FaArrowRightLong />
                </div>
              </div>
            )}
          </div>
          {/* Third Column */}
          <div className="column third-column mt-[-45%] ml-[-30%] ml-[0%] sm:ml-[0%] md:ml-[0%] lg:ml-[0%] xl:ml-[-30%] 2xl:ml-[0%]">
            {uniqueCategoryNames.includes("Sports Activities") && (
              <div
                onClick={() =>
                  handleEventClick(
                    events.find(
                      (event) => event.category_name === "Sports Activities"
                    )
                  )
                }
              >
                <div className="image-box">
                  <h3 style={{ cursor: "pointer",color:'red' }}>Sports Activities</h3>
                  <img src={event1} alt="Sports" className="pt-4" />
                </div>
                <div className="arrow  ml-[84%] sm:ml-[95%] md:ml-[95%] lg:ml-[95%] xl:ml-[93%] 2xl:ml-[93%] pt-2">
                  <FaArrowRightLong />
                </div>
              </div>
            )}
            {uniqueCategoryNames.includes("Campus") && (
              <div
                onClick={() =>
                  handleEventClick(
                    events.find((event) => event.category_name === "Campus")
                  )
                }
              >
                <div className="image-box">
                  <h3 style={{ cursor: "pointer",color:'red' }}>Campus</h3>
                  <img src={campus} alt="Campus" className="pt-4" />
                </div>
                <div className="arrow ml-[84%] sm:ml-[95%] md:ml-[95%] lg:ml-[95%] xl:ml-[93%] 2xl:ml-[93%] pt-2">
                  <FaArrowRightLong />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Events;
